<template>
    <v-card class="mt-4" :disabled="disabled" :light="isLight">
        <v-card-title :class="`subtitle-2 font-weight-bold ${pb ? `pb-${pb}` : ''}`">
            <v-row :align="titleAlign">
                <v-col :cols="titleCols" class="py-0">{{ headline }}</v-col> <slot name="buttons" />
            </v-row>
        </v-card-title>
        <v-card-text v-if="hasText">
            <slot />
        </v-card-text>
        <slot name="actions" />
    </v-card>
</template>
<script>
export default {
    props: {
        headline: String,
        disabled: { type: Boolean, default: false },
        pb: { type: String, default: null },
        titleAlign: { type: String, default: "start" },
        titleCols: { type: String, default: null },
        hasText: { type: Boolean, default: true },
        isLight: { type: Boolean, default: true },
    },
};
</script>
